import React from 'react';
import { Card, Box, Typography, alpha } from '@mui/material';
import { motion } from 'framer-motion';

const StatsCard = ({ title, value, icon, color, subtitle, trend }) => {
  const colors = {
    primary: '#0A2647',
    success: '#2ecc71',
    warning: '#f39c12',
    danger: '#e74c3c',
    info: '#3498db',
    purple: '#9b59b6'
  };

  const selectedColor = colors[color] || colors.primary;

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <Card sx={{
        p: 3,
        borderRadius: 3,
        background: `linear-gradient(135deg, ${selectedColor}08 0%, ${selectedColor}03 100%)`,
        border: `1px solid ${alpha(selectedColor, 0.1)}`,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 120,
          height: 120,
          background: `radial-gradient(circle, ${alpha(selectedColor, 0.05)} 0%, transparent 70%)`,
          borderRadius: '50%',
          transform: 'translate(30%, -30%)'
        }
      }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{ 
              color: 'text.secondary',
              fontWeight: 500,
              mb: 0.5
            }}>
              {title}
            </Typography>
            <Typography variant="h4" sx={{ 
              fontWeight: 700,
              color: selectedColor,
              mb: 0.5
            }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {subtitle}
              </Typography>
            )}
            {trend && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
                <Typography variant="caption" sx={{ 
                  color: trend > 0 ? 'success.main' : 'error.main',
                  fontWeight: 600
                }}>
                  {trend > 0 ? '+' : ''}{trend}%
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  vs mês anterior
                </Typography>
              </Box>
            )}
          </Box>
          <Box sx={{
            bgcolor: alpha(selectedColor, 0.1),
            borderRadius: '50%',
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {React.cloneElement(icon, { 
              sx: { 
                color: selectedColor,
                fontSize: 32
              }
            })}
          </Box>
        </Box>
      </Card>
    </motion.div>
  );
};

export default StatsCard;
